module.exports = __webpack_public_path__ + "img/error-detection.83a4e3f7.png";